<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "landingHome"
}
</script>

<style scoped>

</style>